import { MobiDocument } from './MobiDocument';
import { PlageFonctionnementDocument } from './PlageFonctionnementDocument';

export class ElementFriseActiviteDocument extends MobiDocument{
    private _id: string;
    private _rev: string;
    private id: number;
    private activite_id: number;
    private plageFonctionnement_id: number;
    private heure_debut: string;
    private heure_fin: string;
    private heure_debut_fixe: string | null;
    private heure_fin_fixe: string | null;
    private service_id : number;


    public constructor(elementfrise: any) {
        super()
        this._id = elementfrise._id;
        this._rev = elementfrise._rev;
        this.id = elementfrise.id;
        this.activite_id = elementfrise.activite_id;
        this.plageFonctionnement_id = elementfrise.plageFonctionnement_id;
        this.heure_debut = elementfrise.heure_debut;
        this.heure_fin = elementfrise.heure_fin;
        this.service_id = elementfrise.service_id;
        if(typeof elementfrise.heure_debut_fixe !== 'undefined')
            this.heure_debut_fixe = elementfrise.heure_debut_fixe;
        else
            this.heure_debut_fixe = null
        if(typeof elementfrise.heure_fin_fixe !== 'undefined')
            this.heure_fin_fixe = elementfrise.heure_fin_fixe;
        else
            this.heure_fin_fixe = null
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getActivite_id(): number {
        return this.activite_id;
    }

    public setActivite_id(activite_id: number): void {
        this.activite_id = activite_id;
    }

    public getPlageFonctionnement_id(): number {
        return this.plageFonctionnement_id;
    }

    public setPlageFonctionnement_id(plageFonctionnement_id: number): void {
        this.plageFonctionnement_id = plageFonctionnement_id;
    }

    public getHeure_debut(): string {
        return this.heure_debut;
    }

    public setHeure_debut(heure_debut: string): void {
        this.heure_debut = heure_debut;
    }

    public getHeure_fin(): string {
        return this.heure_fin;
    }

    public setHeure_fin(heure_fin: string): void {
        this.heure_fin = heure_fin;
    }

    public getHeure_debut_fixe(): string|null {
        return this.heure_debut_fixe;
    }

    public setHeure_debut_fixe(heure_debut_fixe: string|null): void {
        this.heure_debut_fixe = heure_debut_fixe;
    }

    public getHeure_fin_fixe(): string|null {
        return this.heure_fin_fixe;
    }

    public setHeure_fin_fixe(heure_fin_fixe: string|null): void {
        this.heure_fin_fixe = heure_fin_fixe;
    }

    public getService_id(): number {
        return this.service_id;
    }

    public setService_id(service_id: number): void {
        this.service_id = service_id;
    }

    public getPlageFonctionnement(): PlageFonctionnementDocument {
        return this.memdb.findOne({
            doctype: "PlageFonctionnementDocument",
            fkey: "id",
            fvalue: this.plageFonctionnement_id
        });
    }
}